import { useEffect } from 'react';

interface SeoProps {
  title: string;
  description: string;
  keywords?: string;
}

export default function Seo({ title, description, keywords }: SeoProps) {
  useEffect(() => {
    const fullTitle = `${title} | 校园爆点`;
    document.title = fullTitle;
    let metaDescription = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = description;

    if (keywords) {
      let metaKeywords = document.querySelector<HTMLMetaElement>('meta[name="keywords"]');
      if (!metaKeywords) {
        metaKeywords = document.createElement('meta');
        metaKeywords.name = 'keywords';
        document.head.appendChild(metaKeywords);
      }
      metaKeywords.content = keywords;
    }
    return () => {
      window.scrollTo(0, 0);
    };
  }, [title, description, keywords]);
  return null;
}